import React, { useEffect, useState } from "react";
import {
  Row,
  Label,
  Input,
  Form,
  FormGroup,
  FormFeedback,
  Col,
  Button,
} from "reactstrap";
import { useFormik } from "formik";
import * as yup from "yup";
//Import Flatepicker
import "flatpickr/dist/themes/material_blue.css";
import {
  sendIndividualOTPVerification,
  validateIndividualOTP,
} from "../../../helpers/AuthType/authBackend";
import { setAuthorization } from "../../../helpers/api_helper";

interface ValidationInformationProps {
  onSubmit: (values: any) => void;
  onBack: () => void;
  data?: any;
}

const ValidationRepresentativeInfo = ({
  onSubmit,
  onBack,
  data,
}: ValidationInformationProps) => {
  //meta title
  document.title = "Ditobanx";

  const [verifiedEmail, setVerifiedEmail] = useState(false);
  const [verifiedPhone, setVerifiedPhone] = useState(false);
  const [error, setError] = useState<string | null>("");
  const [errorEmail, setErrorEmail] = useState<string | null>("");
  const [timeLeft, setTimeLeft] = useState(0);
  const [timerActive, setTimerActive] = useState(false);
  const [timeLeftPhone, setTimeLeftPhone] = useState(0);
  const [timerActivePhone, setTimerActivePhone] = useState(false);

  // console.log("data", data);

  useEffect(() => {
    setAuthorization(localStorage.getItem("publicToken"));

    let timer: NodeJS.Timeout;

    if (timerActive && timeLeft > 0) {
      timer = setInterval(() => {
        setTimeLeft((prevTime) => prevTime - 1);
      }, 1000);
    }

    if (timeLeft === 0) {
      setTimerActive(false);
    }
    let timerPhone: NodeJS.Timeout;
    if (timerActivePhone && timeLeftPhone > 0) {
      timerPhone = setInterval(() => {
        setTimeLeftPhone((prevTime) => prevTime - 1);
      }, 1000);
    }
    if (timeLeftPhone === 0) {
      setTimerActivePhone(false);
    }

    if (error) {
      const timer = setTimeout(() => setError(null), 3000);
      return () => clearTimeout(timer);
    }
    if (errorEmail) {
      const timer = setTimeout(() => setErrorEmail(null), 3000);
      return () => clearTimeout(timer);
    }

    return () => {
      clearInterval(timer);
      clearInterval(timerPhone);
    };
  }, [
    timerActive,
    timeLeft,
    timerActivePhone,
    timeLeftPhone,
    error,
    errorEmail,
  ]);

  const sendOTPEmail = async () => {
    try {
      const obj = {
        email: data.representativeInfo.email,
      };
      const response = await sendIndividualOTPVerification(obj);
      // console.log(response);
    } catch (error) {
      console.log(error);
      // setError(error);
    } finally {
      // Activar cuenta regresiva de 5 minutos (300 segundos)
      setTimeLeft(300);
      setTimerActive(true);
    }
  };

  const sendOTPhone = async () => {
    try {
      const obj = {
        phone_number:
          data.representativeInfo.phoneCode + data.representativeInfo.phone,
      };
      const response = await sendIndividualOTPVerification(obj);
      // console.log(response);
    } catch (error) {
      console.log(error);
      // setError(error);
    } finally {
      setTimeLeftPhone(300);
      setTimerActivePhone(true);
    }
  };

  const handleVerifyEmail = async () => {
    try {
      // console.log("Verificando...");
      const obj = {
        email: data.representativeInfo.email,
        otp: String(formik.values.code_otp_email),
      };
      // console.log(obj);
      const response = await validateIndividualOTP(obj);
      if (response) {
        setVerifiedEmail(true);
        setTimeLeft(0);
        setTimerActive(false);
      }
      // console.log(response);
    } catch (error: any) {
      // console.log(error);
      const errorMessage = JSON.parse(JSON.parse(error));
      setErrorEmail(errorMessage.message);
      setTimeout(() => setErrorEmail(null), 3000);
    }
  };

  const handleVerifyPhone = async () => {
    try {
      // console.log("Verificando...");
      const obj = {
        phone_number:
          String(data.representativeInfo.phoneCode) +
          String(data.representativeInfo.phone),
        otp: String(formik.values.code_otp_phone),
      };
      // console.log(obj);
      const response = await validateIndividualOTP(obj);
      if (response) {
        setVerifiedPhone(true);
        setTimeLeftPhone(0);
        setTimerActivePhone(false);
      }
      // console.log(response);
    } catch (error: any) {
      // console.log(error);
      const errorMessage = JSON.parse(JSON.parse(error));
      setError(errorMessage.message);
      setTimeout(() => setError(null), 3000);
    }
  };

  const formatTime = (seconds: number) => {
    const min = Math.floor(seconds / 60)
      .toString()
      .padStart(2, "0");
    const sec = (seconds % 60).toString().padStart(2, "0");
    return `${min}:${sec}`;
  };

  const formik: any = useFormik({
    initialValues: {
      email: (data.representativeInfo && data.representativeInfo.email) || "",
      code_otp_email: "",
      code_otp_phone: "",
      phone:
        (data.representativeInfo &&
          data.representativeInfo.phoneCode +
            " " +
            data.representativeInfo.phone) ||
        "",
    },
    validationSchema: yup.object().shape({
      email: yup.string().email().required("Please Enter Your Email"),
      code_otp_email: yup.number().required(""),
      code_otp_phone: yup.number().required(""),
      phone: yup.number().required("Please Enter Your Phone"),
    }),
    onSubmit: (values: any) => {
      // console.log("values", values);
      onSubmit(values);
    },
  });

  return (
    <React.Fragment>
      <Form onSubmit={formik.handleSubmit} autoComplete="off">
        {/* EMAIL */}
        <FormGroup className="mb-3">
          <Row>
            <Col lg={6}>
              <Label htmlFor="email"> Correo Electronico </Label>
              <div className="d-flex gap-2">
                <div className="flex-grow-1 bd-highligh">
                  <Input
                    type="text"
                    id="email"
                    placeholder="Verifique su correo electronico"
                    name="email"
                    disabled={verifiedEmail || true}
                    value={formik.values.email || ""}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    invalid={
                      formik.touched.email && formik.errors.email ? true : false
                    }
                  />
                  {formik.touched.email && formik.errors.email ? (
                    <FormFeedback type="invalid">
                      {formik.errors.email}
                    </FormFeedback>
                  ) : null}
                </div>
                <div className="bd-highlight">
                  <button
                    type="button"
                    className="btn btn-success"
                    onClick={sendOTPEmail}
                    disabled={timeLeft > 0 || verifiedEmail ? true : false}
                  >
                    Enviar Codigo
                  </button>
                </div>
              </div>
            </Col>
            <Col lg={6}>
              <Label htmlFor="code_otp_email"> Codigo </Label>
              <div className="d-flex gap-2">
                <div className="flex-grow-1 bd-highligh">
                  <Input
                    type="number"
                    id="code_otp_email"
                    placeholder="Codigo OTP"
                    name="code_otp_email"
                    disabled={verifiedEmail}
                    value={formik.values.code_otp_email}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    invalid={
                      formik.touched.code_otp_email &&
                      formik.errors.code_otp_email
                        ? true
                        : false
                    }
                  />
                  {formik.touched.code_otp_email &&
                  formik.errors.code_otp_email ? (
                    <FormFeedback type="invalid">
                      {formik.errors.code_otp_email}
                    </FormFeedback>
                  ) : null}
                </div>
                <div className="bd-highlight">
                  <button
                    type="button"
                    className="btn btn-success"
                    onClick={handleVerifyEmail}
                    disabled={verifiedEmail}
                  >
                    {verifiedEmail ? (
                      <i className="fas fa-check check-icon"></i>
                    ) : (
                      "Verificar"
                    )}
                  </button>
                </div>
              </div>
              <p>
                Tiempo restante: {timeLeft > 0 ? formatTime(timeLeft) : "00:00"}
              </p>
              {errorEmail && (
                <div
                  className="alert alert-danger mt-3 animate__animated animate__fadeInDown"
                  role="alert"
                >
                  <i className="fas fa-exclamation-triangle me-2"></i>{" "}
                  {errorEmail}
                </div>
              )}
            </Col>
          </Row>
        </FormGroup>

        {/* CODE OTP PHONE */}
        <FormGroup className="mb-3">
          <Row>
            <Col lg={6}>
              <Label htmlFor="phone"> Telefono </Label>
              <div className="d-flex gap-2">
                <div className="flex-grow-1 bd-highligh">
                  <Input
                    type="text"
                    id="phone"
                    placeholder="Verifique su numero de telefono"
                    name="phone"
                    disabled={verifiedPhone || true}
                    value={formik.values.phone || ""}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    invalid={
                      formik.touched.phone && formik.errors.phone ? true : false
                    }
                  />
                  {formik.touched.phone && formik.errors.phone ? (
                    <FormFeedback type="invalid">
                      {formik.errors.phone}
                    </FormFeedback>
                  ) : null}
                </div>
                <div className="bd-highlight">
                  <button
                    type="button"
                    className="btn btn-success"
                    onClick={sendOTPhone}
                    disabled={timeLeftPhone > 0 || verifiedPhone ? true : false}
                  >
                    Enviar Codigo
                  </button>
                </div>
              </div>
            </Col>
            <Col lg={6}>
              <Label htmlFor="code_otp_phone">Código</Label>
              <div className="d-flex gap-2">
                <div className="flex-grow-1 bd-highligh">
                  <Input
                    type="number"
                    id="code_otp_phone"
                    placeholder="Código OTP"
                    name="code_otp_phone"
                    value={formik.values.code_otp_phone}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    invalid={
                      formik.touched.code_otp_phone &&
                      formik.errors.code_otp_phone
                        ? true
                        : false
                    }
                    disabled={verifiedPhone} // Se deshabilita al verificar
                  />
                  {formik.touched.code_otp_phone &&
                    formik.errors.code_otp_phone && (
                      <FormFeedback type="invalid">
                        {formik.errors.code_otp_phone}
                      </FormFeedback>
                    )}
                </div>
                <div className="bd-highlight">
                  <button
                    type="button"
                    className="btn btn-success"
                    onClick={handleVerifyPhone}
                    disabled={verifiedPhone} // Se deshabilita al verificar
                  >
                    {verifiedPhone ? (
                      <i className="fas fa-check check-icon"></i>
                    ) : (
                      "Verificar"
                    )}
                  </button>
                </div>
              </div>
              <p>
                Tiempo restante:{" "}
                {timeLeftPhone > 0 ? formatTime(timeLeftPhone) : "00:00"}
              </p>
              {error && (
                <div
                  className="alert alert-danger mt-2 d-flex align-items-center"
                  role="alert"
                >
                  <i className="fas fa-exclamation-triangle me-2"></i>
                  {error}
                </div>
              )}
            </Col>
          </Row>
        </FormGroup>

        <div
          style={{
            marginTop: "20px",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Button
            type="button"
            className="btn btn-secondary me-2"
            onClick={onBack}
          >
            Regresar
          </Button>
          <Button type="submit" className="btn btn-primary">
            Siguiente
          </Button>
        </div>
      </Form>
    </React.Fragment>
  );
};

export default ValidationRepresentativeInfo;
